import React from 'react'
import NavbarDashboard from '../../components/Admin/NavbarDashboard/NavbarDashboard'

export default function Header({ logo }) {
    return (
        <div>
            <NavbarDashboard logo={logo} />
        </div>
    )
}
